<template src="./vc-pinboard-item.html"></template>

<script lang="ts">
import formatName from 'filters/format-name'
import { getElapsedTime } from 'util/time-utils'
import bu from 'util/browser-utils'
import PinboardMedia from 'objects/media/PinboardMedia.vue'
import { truncateText } from 'util/text-utils'
import RatingStars from 'components/rating/RatingStars.vue'
import { TYPE_PHOTO } from 'util/media-utils'

export default {
  props: {
    hoverTitleMaxLength: {
      type: Number,
      required: true
    },
    maxCaptionLength: Number,
    media: {
      type: Object,
      required: true
    },
    showCaption: Boolean,
    showDatestamp: Boolean,
    showReviewStars: Boolean,
    tileWidth: {
      type: Number,
      default: 0
    },
    userNameMaxLength: {
      type: Number,
      required: true
    }
  },
  components: {
    'tt-pinboard-media': PinboardMedia,
    'tt-rating-stars': RatingStars
  },
  computed: {
    author() {
      return this.isUserNameTruncated ?
        this.formattedName.substring(0, this.userNameMaxLength) : this.formattedName
    },
    catItem() {
      return this.media.catItem ? this.media.catItem : this.media.catItems[0]
    },
    caption() {
      return this.truncatedText || this.media.text
    },
    displayReviewStars() {
      return this.media.reviewCount > 0 && this.showReviewStars
    },
    elapsedTime() {
      return getElapsedTime(this.media.dateCreatedMillis)
    },
    formattedName() {
      return formatName(this.media.user)
    },
    hoverTitle() {
      const truncated = truncateText(this.catItem.title, this.hoverTitleMaxLength)
      return truncated ? `${truncated}&hellip;` : this.catItem.title
    },
    isCaptionTruncated() {
      return this.truncatedText ? true : false
    },
    isOnMobile() {
      return bu.isMobileDevice()
    },
    isUserNameTruncated() {
      return this.formattedName.length > this.userNameMaxLength
    },
    linkTitle() {
      const type = this.media.type === TYPE_PHOTO ? 'photo' : 'video'
      return this.$msg(`vcPinboardItem.opensMediaModal.${type}`, [this.author])
    },
    truncatedText() {
      return truncateText(this.media.text, this.maxCaptionLength)
    }
  }
}
</script>

<style lang="scss" src="./vc-pinboard-item.scss"></style>
